import { createSlice } from "@reduxjs/toolkit";

const initialState = {
 banner: {
    image: {
        //sm: `/images/${process.env.REACT_APP_THEME}/banner-sm@2x.jpg`,
        sm: [
            { src: `/images/${process.env.REACT_APP_THEME}/banner4.png` },
            { src: `/images/${process.env.REACT_APP_THEME}/banner5.png` },
            { src: `/images/${process.env.REACT_APP_THEME}/banner6.png` },
            {
                src: `/images/${process.env.REACT_APP_THEME}/banner7.jpg`,
                button: { href: 'https://www.audi.in/en/models/q3/q3-suv/?channelId=3492&utm_source=Search&utm_medium=Q3&utm_term=Mixed&utm_content=P1-P2-P3&utm_campaign=PHD-Audi-India-Approved-Performance-Campaign-Search-Q3-P1-P2-P3', label: 'Register Interest - Audi Q3' },
            },
        ],
        // md: `/images/${process.env.REACT_APP_THEME}/banner.jpg`,
        md: [
            { src: `/images/${process.env.REACT_APP_THEME}/banner4.png` },
            { src: `/images/${process.env.REACT_APP_THEME}/banner5.png` },
            { src: `/images/${process.env.REACT_APP_THEME}/banner6.png` },
            {
                src: `/images/${process.env.REACT_APP_THEME}/banner7.jpg`,
                button: { href: 'https://www.audi.in/en/models/q3/q3-suv/?channelId=3492&utm_source=Search&utm_medium=Q3&utm_term=Mixed&utm_content=P1-P2-P3&utm_campaign=PHD-Audi-India-Approved-Performance-Campaign-Search-Q3-P1-P2-P3', label: 'Register Interest - Audi Q3' },
            },
        ],
        xl: [
            { src: `/images/${process.env.REACT_APP_THEME}/banner4.png` },
            { src: `/images/${process.env.REACT_APP_THEME}/banner5.png` },
            { src: `/images/${process.env.REACT_APP_THEME}/banner6.png` },
            {
                src: `/images/${process.env.REACT_APP_THEME}/banner7.jpg`,
                button: { href: 'https://www.audi.in/en/models/q3/q3-suv/?channelId=3492&utm_source=Search&utm_medium=Q3&utm_term=Mixed&utm_content=P1-P2-P3&utm_campaign=PHD-Audi-India-Approved-Performance-Campaign-Search-Q3-P1-P2-P3', label: 'Register Interest - Audi Q3' },
            },
        ],
    },
    title: 'Enjoy Peace Of Mind<br> With Audi Approved <span class="em">:plus</span>',
    link: {
        text: 'Explore pre-owned Audi Cars',
        href: '/buy'
    }
 }
};

const homeSlice = createSlice({
  name: "homeData",
  initialState: initialState,
  reducers: {},
  extraReducers: {},
});

export default homeSlice.reducer;
